import { render, staticRenderFns } from "./VacancyGallery.vue?vue&type=template&id=15d7cbe8&scoped=true&"
import script from "./VacancyGallery.vue?vue&type=script&lang=ts&"
export * from "./VacancyGallery.vue?vue&type=script&lang=ts&"
import style0 from "./VacancyGallery.vue?vue&type=style&index=0&id=15d7cbe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d7cbe8",
  null
  
)

export default component.exports